import * as React from "react"

import { cn } from "@/utils"

export interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Size in pixels (default 24) */
  size?: number
  /** Show spinner overlay with children content */
  spinning?: boolean
}

const Spinner = React.forwardRef<HTMLDivElement, SpinnerProps>(
  ({ className, size = 24, spinning, children, ...props }, ref) => {
    const spinner = (
      <div
        ref={ref}
        role="status"
        aria-label="Loading"
        className={cn("inline-flex items-center justify-center", className)}
        {...props}
      >
        <svg
          className="animate-spin text-primary"
          width={size}
          height={size}
          viewBox="0 0 24 24"
          fill="none"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
          />
        </svg>
        <span className="sr-only">Loading...</span>
      </div>
    )

    if (children) {
      return (
        <div className="relative">
          {spinning && (
            <div className="absolute inset-0 z-10 flex items-center justify-center bg-background/60">
              {spinner}
            </div>
          )}
          <div className={cn(spinning && "opacity-50 pointer-events-none")}>
            {children}
          </div>
        </div>
      )
    }

    return spinner
  }
)
Spinner.displayName = "Spinner"

export { Spinner }
